/**
 * Copyright 2025 (c) Karsten Röthig, FVA GmbH (for umati and VDW e.V.)
 */
import React, { ReactElement } from 'react';
import { TemplateContext } from 'templates/pubSub/types/TemplateContextType';
import { SectionRowElementTable } from 'templates/pubSub/types/TemplateType';
import { NodeIdentifier } from 'utilities/PubSub/PubSubAddressSpace';
import TemplateHelperPubSub from 'utilities/TemplateHelperPubSub';
import SectionElementContentTableCell from './SectionElementContentTableCell';

interface ISectionElementContentTableRowProps {
  templateContext: TemplateContext;
  element: SectionRowElementTable;
  startingNodeId?: NodeIdentifier;
}

export default function SectionElementContentTableRow(props: ISectionElementContentTableRowProps): ReactElement {
  return (
    <tr>
      {props.element.columns.map((column, columnIndex) => (
        <SectionElementContentTableCell
          key={TemplateHelperPubSub.getPlaceholderKey(column.id, columnIndex)}
          templateContext={props.templateContext}
          column={column}
          startingNodeId={props.startingNodeId}
        />
      ))}
    </tr>
  );
}
